import {defineStore} from "pinia";
import api from "@/plugins/axios"

export const useBackupSettingStore = defineStore('backup-settings', {
    state: () => ({
        items: [],
        item: [],
    }),
    actions: {
        async getList(filters) {
            try {
                const {data} = await api.get(`backup-settings`, {params: filters});
                this.items = data;
                return this.items
            } catch (error) {
                console.error(error);
            }
        },
        async create(params) {
            try {
                const {data} = await api.post(`backup-settings`, params);
                this.item = data;
                return this.item
            } catch (error) {
                console.error(error);
            }
        },
        async update(id, params) {
            try {
                await api.put(`backup-settings/${id}`, params);
            } catch (error) {
                console.error(error);
            }
        },
    }
})
